import React, { useEffect, useState } from "react";
import { message } from "antd";
import styled from "styled-components";

import colors from "constants/palette";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const ReactDraft = ({ form, initialValue }) => {
  const [editorState, setEditorState] = useState(
    initialValue
      ? EditorState.createWithContent(convertFromRaw(JSON.parse(initialValue)))
      : EditorState.createEmpty()
  );

  // Update local editorState if initialValue prop changes
  useEffect(() => {
    if (initialValue) {
      setEditorState(
        EditorState.createWithContent(convertFromRaw(JSON.parse(initialValue)))
      );
    }
  }, [initialValue]);

  const handleEditorChange = (state) => {
    console.log(convertToRaw(state.getCurrentContent()).blocks[0]);

    setEditorState(state);
    // Convert editor state to raw JSON format for Ant Design Form
    const content = convertToRaw(state.getCurrentContent());
    form.setFieldsValue({ description: JSON.stringify(content) });
  };
  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      const isvalid = file.size / 1014 < 512;
      if (!isvalid) {
        message.error(
          `حجم فایل بیشتر از ${0.5} مگابایت میباشد.
              لطفا دوباره تلاش کنید!`
        );
        message.error(
          <a
            href="https://imagecompressor.com/"
            target="_blank"
            rel="noreferrer"
          >
            برای کاهش حجم تصویر کلیک کنید
          </a>
        );

        reject("too large");
        return false;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const imageUrl = reader.result; // Base64 encoded image
        resolve({ data: { link: imageUrl } }); // Return the image URL
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    });
  };
  return (
    <Container>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        stripPastedStyles={true}
        editorClassName="myEditor"
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "image",
            "emoji",
            "history",
          ],
          inline: {
            options: [
              "bold",
              "italic",
              "underline",
              "strikethrough",
              "superscript",
              "subscript",
            ],
          },
          blockType: {
            options: ["Normal", "H2", "H3", "H4", "H5", "Blockquote"],
          },
          image: {
            uploadCallback: uploadImageCallBack, // Custom image upload handler
            alt: { present: true, mandatory: true }, // Allow alt text
            defaultSize: { height: "auto", width: "100%" }, // Set default image size
          },
        }}
      />
    </Container>
  );
};

export default ReactDraft;

const Container = styled.div`
  direction: ltr;
  .DraftEditor-root {
    min-height: 200px;
    border: 1px solid #d9d9d9 !important;
    padding: 8px;
    background-color: #ffffffed;
  }
  * {
    font-family: vazir;
  }
`;
